import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file useOption
 */
import { useCallback, useEffect, useState } from 'react';
import { useSingleton, useUpdate } from '@tencent/glue-react-use';
import { Option, OptionState } from '@tencent/glue-model-select';
import { getUniqueKey } from '@tencent/glue-util-helper';
import { useSelectInstance } from '../context/select';
import { useOptionGroupInstance } from '../context/option-group';
export function useOption(data) {
  var select = useSelectInstance();
  var optionGroup = useOptionGroupInstance();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      backFill = _useState2[0],
      setBackFill = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  var option = useSingleton(function () {
    return new Option(select, data, getUniqueKey(data.value), optionGroup || undefined);
  });
  var update = useUpdate();
  option.updateOption(data);
  var onItemClick = useCallback(function () {
    var _option$getData = option.getData(),
        optionDisabled = _option$getData.disabled,
        optionReadonly = _option$getData.readonly,
        selected = _option$getData.selected;

    if (!optionDisabled && !optionReadonly) {
      if (select.multiple) {
        option.setOptionState(selected ? OptionState.UNSELECTED : OptionState.SELECTED);
      } else {
        option.setOptionState(OptionState.SELECTED);
      }
    }
  }, []);
  useEffect(function () {
    var onSearchQuery = function onSearchQuery(map) {
      setShow(Boolean(map[option.getId()]));
    };

    var onBackFill = function onBackFill(id) {
      setBackFill(id === option.getId());
    };

    option.addListener('state-updated', update);
    select.addListener('search-query', onSearchQuery);
    select.addListener('back-fill-update', onBackFill);
    return function () {
      option.removeListener('state-updated', update);
      select.removeListener('search-query', onSearchQuery);
      select.removeListener('back-fill-update', onBackFill);
      option.dispose();
    };
  }, []);
  return _objectSpread(_objectSpread({}, option.getData()), {}, {
    id: option.getId(),
    backFill: backFill,
    show: show,
    onItemClick: onItemClick
  });
}